import {CountryCode} from "./countryCode";

export const GREEN_CLAIM_FUTURE_YEAR_LOOKAHEAD = 25;
export const GREEN_CLAIMS_DIRECTIVE_URL = "https://eur-lex.europa.eu/eli/dir/2024/825/oj";
export const GREEN_CLAIM_FALLBACK_LANGUAGE = "en";
export const GREEN_CLAIM_PLURAL_S_LANGUAGES = ["en", "fr", "nl"];
export const GREEN_CLAIM_SEVERITIES = ["group1", "group2"] as const;
export const GREEN_CLAIM_LANGUAGES_BY_COUNTRY: Partial<Record<CountryCode, GreenClaimLanguage[]>> = {
  [CountryCode.AT]: ["de"],
  [CountryCode.BE]: ["nl", "fr"],
  [CountryCode.CH]: ["de", "fr"],
  [CountryCode.DE]: ["de"],
  [CountryCode.DK]: ["da"],
  [CountryCode.FR]: ["fr"],
  [CountryCode.NL]: ["nl"],
  [CountryCode.NO]: ["no"],
  [CountryCode.SE]: ["sv"],
};

export type GreenClaimLanguage = "de" | "da" | "nl" | "sv" | "fr" | "no" | "en";

export interface IGreenClaimTerms {
  group1: string[];
  group2: string[];
}

export const GREEN_CLAIM_TERMS: Record<GreenClaimLanguage, IGreenClaimTerms> = {
  de: {
    group1: [
      "nachhaltig",
      "Nachhaltigkeit",
      "umweltfreundlich",
      "umweltbewusst",
      "umweltgerecht",
      "umweltschonend",
      "schonend für die Umwelt",
      "ökologisch",
      "grün",
      "grüne Wahl",
      "klimafreundlich",
      "naturfreundlich",
      "planetenfreundlich",
      "verantwortungsvoll hergestellt",
    ],
    group2: [
      "klimaneutral",
      "CO2-neutral",
      "kohlenstoffneutral",
      "klimapositiv",
      "CO2-negativ",
      "kohlenstoffnegativ",
      "netto-null",
    ],
  },
  da: {
    group1: [
      "bæredygtig",
      "bæredygtigt",
      "bæredygtighed",
      "miljøvenlig",
      "miljøvenligt",
      "miljørigtig",
      "grøn",
      "grønt",
      "grønt valg",
      "klimavenlig",
      "naturvenlig",
      "planetvenlig",
      "skånsom mod miljøet",
      "ansvarligt produceret",
    ],
    group2: [
      "klimaneutral",
      "kulstofneutral",
      "CO2-neutral",
      "klimapositiv",
      "kulstofnegativ",
      "CO2-negativ",
      "netto nul",
    ],
  },
  nl: {
    group1: [
      "duurzaam",
      "duurzaamheid",
      "milieuvriendelijk",
      "milieubewust",
      "milieuverantwoord",
      "ecologisch",
      "groen",
      "groene keuze",
      "klimaatvriendelijk",
      "natuurvriendelijk",
      "planeetvriendelijk",
      "zacht voor het milieu",
      "verantwoord geproduceerd",
    ],
    group2: [
      "klimaatneutraal",
      "CO2-neutraal",
      "koolstofneutraal",
      "klimaatpositief",
      "CO2-negatief",
      "koolstofnegatief",
      "netto nul",
    ],
  },
  sv: {
    group1: [
      "hållbar",
      "hållbart",
      "hållbarhet",
      "miljövänlig",
      "miljövänligt",
      "miljömedveten",
      "grön",
      "grönt",
      "grönt val",
      "klimatvänlig",
      "naturvänlig",
      "planetvänlig",
      "skonsam mot miljön",
      "ansvarsfullt producerad",
    ],
    group2: ["klimatneutral", "koldioxidneutral", "CO2-neutral", "klimatpositiv", "koldioxidnegativ", "netto noll"],
  },
  fr: {
    group1: [
      "durable",
      "durabilité",
      "écologique",
      "écolo",
      "éco-responsable",
      "respectueux de l'environnement",
      "respectueux du climat",
      "respectueux de la planète",
      "vert",
      "verte",
      "choix vert",
      "doux pour l'environnement",
      "fabriqué de manière responsable",
    ],
    group2: [
      "neutre en carbone",
      "neutre en CO2",
      "climatiquement neutre",
      "neutre pour le climat",
      "positif pour le climat",
      "négatif en carbone",
      "zéro émission nette",
    ],
  },
  no: {
    group1: [
      "bærekraftig",
      "bærekraft",
      "miljøvennlig",
      "miljøbevisst",
      "miljøriktig",
      "grønn",
      "grønt",
      "grønt valg",
      "klimavennlig",
      "naturvennlig",
      "planetvennlig",
      "skånsom mot miljøet",
      "ansvarlig produsert",
    ],
    group2: [
      "klimanøytral",
      "karbonnøytral",
      "CO2-nøytral",
      "klimapositiv",
      "karbonnegativ",
      "CO2-negativ",
      "netto null",
    ],
  },
  en: {
    group1: [
      "sustainable",
      "sustainability",
      "eco",
      "eco-friendly",
      "ecological",
      "green",
      "green choice",
      "eco choice",
      "environmentally friendly",
      "environmentally responsible",
      "environmentally conscious",
      "planet-friendly",
      "planet positive",
      "earth-friendly",
      "nature positive",
      "nature-friendly",
      "kind to the planet",
      "gentle on the environment",
      "climate friendly",
      "low-impact",
      "responsibly made",
    ],
    group2: [
      "carbon neutral",
      "climate neutral",
      "CO2 neutral",
      "100% carbon neutral",
      "carbon negative",
      "climate positive",
      "net zero",
    ],
  },
};
